module.exports = __webpack_public_path__ + "static/img/bui.f3d9fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/bui.png
// module id = NNH/
// module chunks = 1